export default __webpack_public_path__ + "static/media/own_activity.bb0727c7.svg";